import { Component, Input, Injectable, ErrorHandler, ɵɵdefineInjectable, Directive, ɵɵinject, Pipe, ElementRef, Renderer2, NgModule, Injector } from '@angular/core';
import { NavigationEnd, Router, NavigationStart, ActivatedRoute, RouterModule } from '@angular/router';
import { filter } from 'rxjs/operators';
import { ReplaySubject, BehaviorSubject, Subject } from 'rxjs';
import { __awaiter } from 'tslib';
import { NgForm, FormGroup, ReactiveFormsModule, FormsModule } from '@angular/forms';
import { Params, RequestMode, Http as Http$1 } from '@inflight/core-nlx';
import { CommonModule } from '@angular/common';

/**
 * @fileoverview added by tsickle
 * Generated from: lib/route-handlers/google/google-analytics.component.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
import * as ɵngcc0 from '@angular/core';
import * as ɵngcc1 from '@angular/router';
class GoogleAnalyticsComponent {
    /**
     * @param {?} router
     */
    constructor(router) {
        this.router = router;
        if (this.gCode) {
            this.initGoogleAnalytics();
        }
        this.router.events.subscribe((/**
         * @param {?} event
         * @return {?}
         */
        (event) => {
            if (event instanceof NavigationEnd && window.ga && event.urlAfterRedirects) {
                window.ga('set', 'page', event.urlAfterRedirects);
                window.ga('send', 'pageview');
            }
        }));
    }
    /**
     * @param {?} value
     * @return {?}
     */
    set googleCode(value) {
        this.gCode = value;
        if (this.gCode) {
            if (!window.ga) {
                this.initGoogleAnalytics();
            }
            window.ga('create', this.gCode, 'auto');
            this.gaSubscription = this.router.events.subscribe((/**
             * @param {?} event
             * @return {?}
             */
            (event) => {
                if (event instanceof NavigationEnd && window.ga && event.urlAfterRedirects) {
                    window.ga('set', 'page', event.urlAfterRedirects);
                    window.ga('send', 'pageview');
                }
            }));
        }
        else {
            if (this.gaSubscription) {
                this.gaSubscription.unsubscribe();
            }
        }
    }
    /**
     * @return {?}
     */
    ngOnInit() { }
    /**
     * @private
     * @return {?}
     */
    initGoogleAnalytics() {
        ((/**
         * @param {?} i
         * @param {?} s
         * @param {?} o
         * @param {?} g
         * @param {?} r
         * @param {?=} a
         * @param {?=} m
         * @return {?}
         */
        function (i, s, o, g, r, a, m) {
            i['GoogleAnalyticsObject'] = r;
            i[r] = i[r] || (/**
             * @return {?}
             */
            function () { (i[r].q = i[r].q || []).push(arguments); })
                , i[r].l = 1 * (/** @type {?} */ (new Date()));
            a = s.createElement(o),
                m = s.getElementsByTagName(o)[0];
            a.async = 1;
            a.src = g;
            m.parentNode.insertBefore(a, m);
        }))(window, document, 'script', 'https://www.google-analytics.com/analytics.js', 'ga');
    }
}
GoogleAnalyticsComponent.ɵfac = function GoogleAnalyticsComponent_Factory(t) { return new (t || GoogleAnalyticsComponent)(ɵngcc0.ɵɵdirectiveInject(ɵngcc1.Router)); };
GoogleAnalyticsComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: GoogleAnalyticsComponent, selectors: [["tracking-analytics"]], inputs: { googleCode: "googleCode" }, decls: 1, vars: 0, template: function GoogleAnalyticsComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelement(0, "div");
    } }, encapsulation: 2 });
/** @nocollapse */
GoogleAnalyticsComponent.ctorParameters = () => [
    { type: Router }
];
GoogleAnalyticsComponent.propDecorators = {
    googleCode: [{ type: Input }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(GoogleAnalyticsComponent, [{
        type: Component,
        args: [{
                selector: 'tracking-analytics',
                template: '<div></div>'
            }]
    }], function () { return [{ type: ɵngcc1.Router }]; }, { googleCode: [{
            type: Input
        }] }); })();
if (false) {
    /**
     * @type {?}
     * @private
     */
    GoogleAnalyticsComponent.prototype.gCode;
    /**
     * @type {?}
     * @private
     */
    GoogleAnalyticsComponent.prototype.ga;
    /**
     * @type {?}
     * @private
     */
    GoogleAnalyticsComponent.prototype.gaSubscription;
    /**
     * @type {?}
     * @private
     */
    GoogleAnalyticsComponent.prototype.router;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/settings/settings.config.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * @record
 */
function IIFAppConfig() { }
if (false) {
    /** @type {?|undefined} */
    IIFAppConfig.prototype.EnvironmentAlias;
    /** @type {?|undefined} */
    IIFAppConfig.prototype.resourcePrefix;
    /** @type {?|undefined} */
    IIFAppConfig.prototype.IFURLPostfix;
    /** @type {?|undefined} */
    IIFAppConfig.prototype.IFURLPrefix;
    /** @type {?|undefined} */
    IIFAppConfig.prototype.InFlightID;
    /** @type {?|undefined} */
    IIFAppConfig.prototype.debugOn;
    /** @type {?|undefined} */
    IIFAppConfig.prototype.isSSO;
    /** @type {?|undefined} */
    IIFAppConfig.prototype.isSSOBounce;
    /** @type {?|undefined} */
    IIFAppConfig.prototype.googleTagManager;
    /** @type {?|undefined} */
    IIFAppConfig.prototype.features;
    /** @type {?|undefined} */
    IIFAppConfig.prototype.activateOptimize;
    /** @type {?|undefined} */
    IIFAppConfig.prototype.IFInitSessionURL;
    /** @type {?|undefined} */
    IIFAppConfig.prototype.IFMode;
    /** @type {?} */
    IIFAppConfig.prototype.Properties;
}
class SettingsConfig {
    /**
     * @param {?} value
     * @return {?}
     */
    set debugOn(value) {
        this._debugOn = value;
    }
    /**
     * @return {?}
     */
    get debugOn() {
        return this._debugOn;
    }
    /**
     * @param {?} value
     * @return {?}
     */
    set isSSO(value) {
        this._isSSO = value;
    }
    /**
     * @return {?}
     */
    get isSSO() {
        return this._isSSO;
    }
    /**
     * @param {?} value
     * @return {?}
     */
    set isSSOBounce(value) {
        this._isSSOBounce = value;
    }
    /**
     * @return {?}
     */
    get isSSOBounce() {
        return this._isSSOBounce;
    }
    /**
     * @return {?}
     */
    get hasResourcePrefix() {
        return this._hasResourcePrefix;
    }
    /**
     * @return {?}
     */
    get resourcePrefix() {
        return this._resoucePrefix;
    }
    /**
     * @param {?} value
     * @return {?}
     */
    set resourcePrefix(value) {
        this._resoucePrefix = value;
        this._hasResourcePrefix = true;
    }
    /**
     * @return {?}
     */
    get hasEnvironmentAlias() {
        return this._hasEnvironmentAlias;
    }
    /**
     * @return {?}
     */
    get EnvironmentAlias() {
        return this._EnvironmentAlias;
    }
    /**
     * @param {?} value
     * @return {?}
     */
    set EnvironmentAlias(value) {
        this._EnvironmentAlias = value;
        this._hasEnvironmentAlias = true;
    }
    /**
     * @return {?}
     */
    get hasIFURLPrefix() {
        return this._hasIFURLPrefix;
    }
    /**
     * @return {?}
     */
    get IFURLPrefix() {
        return this._IFURLPrefix;
    }
    /**
     * @param {?} value
     * @return {?}
     */
    set IFURLPrefix(value) {
        this._IFURLPrefix = value;
        this._hasIFURLPrefix = true;
    }
    /**
     * @return {?}
     */
    get hasInFlightID() {
        return this._hasInFlightId;
    }
    /**
     * @return {?}
     */
    get InFlightID() {
        return this._InFlightId;
    }
    /**
     * @param {?} value
     * @return {?}
     */
    set InFlightID(value) {
        this._InFlightId = value;
        this._hasInFlightId = true;
    }
    /**
     * @return {?}
     */
    get hasIFURLPostfix() {
        return this._hasIFURLPostfix;
    }
    /**
     * @return {?}
     */
    get IFURLPostfix() {
        return this._IFURLPostfix;
    }
    /**
     * @param {?} value
     * @return {?}
     */
    set IFURLPostfix(value) {
        this._IFURLPostfix = value;
        this._hasIFURLPostfix = true;
    }
    /**
     * @return {?}
     */
    get IFInitSessionURL() {
        return this._IFInitSessionURL;
    }
    /**
     * @param {?} value
     * @return {?}
     */
    set IFInitSessionURL(value) {
        this._IFInitSessionURL = value;
    }
    /**
     * @return {?}
     */
    get IFMode() {
        return this._IFMode;
    }
    /**
     * @param {?} value
     * @return {?}
     */
    set IFMode(value) {
        this._IFMode = value;
    }
    /**
     * @return {?}
     */
    get Properties() {
        return this._properties;
    }
    /**
     * @param {?} feature
     * @return {?}
     */
    hasFeature(feature) {
        return this.features && this.features.some((/**
         * @param {?} f
         * @return {?}
         */
        f => f === feature));
    }
    constructor() {
        this._properties = new Map();
        this.debugOn = false;
        this._IFURLPrefix = '';
        this._hasIFURLPrefix = false;
        this._resoucePrefix = '';
        this._hasResourcePrefix = false;
        this._InFlightId = '';
        this._hasInFlightId = false;
        this._IFURLPostfix = '';
        this._hasIFURLPostfix = false;
        this._EnvironmentAlias = '';
        this._hasEnvironmentAlias = false;
        this._isSSO = false;
        this._isSSOBounce = false;
        this.activateOptimize = false;
    }
    /**
     * @param {?} cfg
     * @return {?}
     */
    init(cfg) {
        if (cfg.EnvironmentAlias) {
            this.EnvironmentAlias = cfg.EnvironmentAlias;
        }
        if (cfg.IFURLPrefix) {
            this.IFURLPrefix = cfg.IFURLPrefix;
        }
        if (cfg.IFURLPostfix) {
            this.IFURLPostfix = cfg.IFURLPostfix;
        }
        if (cfg.InFlightID) {
            this.InFlightID = cfg.InFlightID;
        }
        if (cfg.resourcePrefix) {
            this.resourcePrefix = cfg.resourcePrefix;
        }
        if (cfg.debugOn) {
            this.debugOn = cfg.debugOn;
        }
        if (cfg.isSSO) {
            this.isSSO = cfg.isSSO;
        }
        if (cfg.isSSOBounce) {
            this.isSSOBounce = cfg.isSSOBounce;
        }
        if (cfg.googleTagManager) {
            this.googleTagManager = cfg.googleTagManager;
        }
        if (cfg.features) {
            this.features = cfg.features;
        }
        if (cfg.activateOptimize) {
            this.activateOptimize = cfg.activateOptimize;
        }
        this.IFInitSessionURL = cfg.IFInitSessionURL;
        this.IFMode = cfg.IFMode;
        if (cfg.Properties) {
            Object.keys(cfg.Properties).forEach((/**
             * @param {?} k
             * @return {?}
             */
            k => this._properties.set(k, cfg.Properties[k])));
        }
    }
}
if (false) {
    /** @type {?} */
    SettingsConfig.prototype.activateOptimize;
    /**
     * @type {?}
     * @private
     */
    SettingsConfig.prototype._debugOn;
    /**
     * @type {?}
     * @private
     */
    SettingsConfig.prototype._isSSO;
    /**
     * @type {?}
     * @private
     */
    SettingsConfig.prototype._isSSOBounce;
    /**
     * @type {?}
     * @private
     */
    SettingsConfig.prototype._hasResourcePrefix;
    /**
     * @type {?}
     * @private
     */
    SettingsConfig.prototype._resoucePrefix;
    /**
     * @type {?}
     * @private
     */
    SettingsConfig.prototype._hasEnvironmentAlias;
    /**
     * @type {?}
     * @private
     */
    SettingsConfig.prototype._EnvironmentAlias;
    /**
     * @type {?}
     * @private
     */
    SettingsConfig.prototype._hasIFURLPrefix;
    /**
     * @type {?}
     * @private
     */
    SettingsConfig.prototype._IFURLPrefix;
    /**
     * @type {?}
     * @private
     */
    SettingsConfig.prototype._hasInFlightId;
    /**
     * @type {?}
     * @private
     */
    SettingsConfig.prototype._InFlightId;
    /**
     * @type {?}
     * @private
     */
    SettingsConfig.prototype._hasIFURLPostfix;
    /**
     * @type {?}
     * @private
     */
    SettingsConfig.prototype._IFURLPostfix;
    /**
     * @type {?}
     * @private
     */
    SettingsConfig.prototype._IFInitSessionURL;
    /**
     * @type {?}
     * @private
     */
    SettingsConfig.prototype._IFMode;
    /** @type {?} */
    SettingsConfig.prototype.googleTagManager;
    /**
     * @type {?}
     * @private
     */
    SettingsConfig.prototype._properties;
    /**
     * @type {?}
     * @private
     */
    SettingsConfig.prototype.features;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/settings/settings.service.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
// for case where it exists on window already
class SettingsService {
    // END for backwards compatibility
    constructor() {
        /** @type {?} */
        const settingsConfig = new SettingsConfig();
        if (window['ifConfig']) {
            settingsConfig.init(ifConfig);
        }
        SettingsService.SETTINGS_STORE[SettingsService.DEFAULT_KEY] = settingsConfig;
    }
    /**
     * @return {?}
     */
    get activateOptimize() {
        return this.defaultSystemSettings.activateOptimize;
    }
    // START for backwards compatibility - USE defaultSystemSettings to access
    /**
     * @return {?}
     */
    get debugOn() {
        return this.defaultSystemSettings.debugOn;
    }
    /**
     * @param {?} value
     * @return {?}
     */
    set debugOn(value) {
        this.defaultSystemSettings.debugOn = value;
    }
    /**
     * @return {?}
     */
    get isSSO() {
        return this.defaultSystemSettings.isSSO;
    }
    /**
     * @return {?}
     */
    get isSSOBounce() {
        return this.defaultSystemSettings.isSSOBounce;
    }
    /**
     * @return {?}
     */
    get hasResourcePrefix() {
        return this.defaultSystemSettings.hasResourcePrefix;
    }
    /**
     * @return {?}
     */
    get resourcePrefix() {
        return this.defaultSystemSettings.resourcePrefix;
    }
    /**
     * @param {?} value
     * @return {?}
     */
    set resourcePrefix(value) {
        this.defaultSystemSettings.resourcePrefix = value;
    }
    /**
     * @return {?}
     */
    get hasEnvironmentAlias() {
        return this.defaultSystemSettings.hasEnvironmentAlias;
    }
    /**
     * @return {?}
     */
    get EnvironmentAlias() {
        return this.defaultSystemSettings.EnvironmentAlias;
    }
    /**
     * @param {?} value
     * @return {?}
     */
    set EnvironmentAlias(value) {
        this.defaultSystemSettings.EnvironmentAlias = value;
    }
    /**
     * @return {?}
     */
    get hasIFURLPrefix() {
        return this.defaultSystemSettings.hasIFURLPrefix;
    }
    /**
     * @return {?}
     */
    get IFURLPrefix() {
        return this.defaultSystemSettings.IFURLPrefix;
    }
    /**
     * @param {?} value
     * @return {?}
     */
    set IFURLPrefix(value) {
        this.defaultSystemSettings.IFURLPrefix = value;
    }
    /**
     * @return {?}
     */
    get hasInFlightID() {
        return this.defaultSystemSettings.hasInFlightID;
    }
    /**
     * @return {?}
     */
    get InFlightID() {
        return this.defaultSystemSettings.InFlightID;
    }
    /**
     * @param {?} value
     * @return {?}
     */
    set InFlightID(value) {
        this.defaultSystemSettings.InFlightID = value;
    }
    /**
     * @return {?}
     */
    get hasIFURLPostfix() {
        return this.defaultSystemSettings.hasIFURLPostfix;
    }
    /**
     * @return {?}
     */
    get IFURLPostfix() {
        return this.defaultSystemSettings.IFURLPostfix;
    }
    /**
     * @param {?} value
     * @return {?}
     */
    set IFURLPostfix(value) {
        this.defaultSystemSettings.IFURLPostfix = value;
    }
    /**
     * @return {?}
     */
    get IFInitSessionURL() {
        return this.defaultSystemSettings.IFInitSessionURL;
    }
    /**
     * @param {?} value
     * @return {?}
     */
    set IFInitSessionURL(value) {
        this.defaultSystemSettings.IFInitSessionURL = value;
    }
    /**
     * @return {?}
     */
    get googleTagManager() {
        return this.defaultSystemSettings.googleTagManager;
    }
    /**
     * @param {?} value
     * @return {?}
     */
    set googleTagManager(value) {
        this.defaultSystemSettings.googleTagManager = value;
    }
    /**
     * @return {?}
     */
    get Properties() {
        return this.defaultSystemSettings.Properties;
    }
    /**
     * @return {?}
     */
    get defaultSystemSettings() {
        return SettingsService.SETTINGS_STORE[SettingsService.DEFAULT_KEY];
    }
    /**
     * @param {?} systemKey
     * @return {?}
     */
    getSystemSettings(systemKey) {
        /** @type {?} */
        const cachedSettings = SettingsService.SETTINGS_STORE[systemKey];
        if (cachedSettings) {
            return cachedSettings;
        }
        /** @type {?} */
        const config = ifConfig[systemKey];
        if (config) {
            /** @type {?} */
            const settings = new SettingsConfig();
            settings.init(config);
            SettingsService.SETTINGS_STORE[systemKey] = settings;
            return settings;
        }
    }
}
SettingsService.ɵfac = function SettingsService_Factory(t) { return new (t || SettingsService)(); };
SettingsService.ɵprov = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjectable({ token: SettingsService, factory: SettingsService.ɵfac });
SettingsService.SETTINGS_STORE = new Map();
SettingsService.DEFAULT_KEY = '____DEFAULT_KEY___';
/** @nocollapse */
SettingsService.ctorParameters = () => [];
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(SettingsService, [{
        type: Injectable
    }], function () { return []; }, null); })();
if (false) {
    /**
     * @type {?}
     * @private
     */
    SettingsService.SETTINGS_STORE;
    /**
     * @type {?}
     * @private
     */
    SettingsService.DEFAULT_KEY;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/route-handlers/google/google-optimize.service.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class GoogleOptimizeService {
    /**
     * @param {?} router
     * @param {?} errorHandler
     * @param {?} settings
     */
    constructor(router, errorHandler, settings) {
        this.router = router;
        this.errorHandler = errorHandler;
        this.settings = settings;
        this.defaultEventName = 'optimize.activate';
        this.router.events.pipe(filter((/**
         * @param {?} evt
         * @return {?}
         */
        evt => evt instanceof NavigationEnd))).subscribe((/**
         * @param {?} event
         * @return {?}
         */
        (event) => {
            if (!this.settings.activateOptimize) {
                return;
            }
            this.triggerOptimize(this.defaultEventName);
        }));
    }
    /**
     * @param {?=} event
     * @return {?}
     */
    triggerOptimize(event = this.defaultEventName) {
        if (!this.settings.activateOptimize) {
            return;
        }
        if (!window.dataLayer) {
            window.dataLayer = [];
        }
        window.dataLayer.push({ 'event': event });
    }
    /**
     * @param {?} param
     * @return {?}
     */
    isABFeature(param) {
        /** @type {?} */
        let value;
        if (window.IFC_AB && window.IFC_AB[param]) {
            value = window.IFC_AB[param];
            try {
                sessionStorage.setItem(`IFC_AB.${param}`, value);
            }
            catch (e) {
                this.errorHandler.handleError(e);
            }
        }
        else {
            try {
                value = sessionStorage.getItem(`IFC_AB.${param}`);
            }
            catch (e) {
                this.errorHandler.handleError(e);
            }
        }
        return value;
    }
}
GoogleOptimizeService.ɵfac = function GoogleOptimizeService_Factory(t) { return new (t || GoogleOptimizeService)(ɵngcc0.ɵɵinject(ɵngcc1.Router), ɵngcc0.ɵɵinject(ɵngcc0.ErrorHandler), ɵngcc0.ɵɵinject(SettingsService)); };
GoogleOptimizeService.ɵprov = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjectable({ token: GoogleOptimizeService, factory: GoogleOptimizeService.ɵfac });
/** @nocollapse */
GoogleOptimizeService.ctorParameters = () => [
    { type: Router },
    { type: ErrorHandler },
    { type: SettingsService }
];
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(GoogleOptimizeService, [{
        type: Injectable
    }], function () { return [{ type: ɵngcc1.Router }, { type: ɵngcc0.ErrorHandler }, { type: SettingsService }]; }, null); })();
if (false) {
    /** @type {?} */
    GoogleOptimizeService.prototype.defaultEventName;
    /**
     * @type {?}
     * @private
     */
    GoogleOptimizeService.prototype.router;
    /**
     * @type {?}
     * @private
     */
    GoogleOptimizeService.prototype.errorHandler;
    /**
     * @type {?}
     * @private
     */
    GoogleOptimizeService.prototype.settings;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/route-handlers/referrer/referrer.service.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class ReferrerService {
    constructor() {
        this.referrerSubject = new ReplaySubject();
        this.referrerKey = 'if_referrer';
        this.referrer = this.referrerSubject.asObservable();
        /** @type {?} */
        let referrerValue = document.referrer;
        if (!referrerValue) {
            try {
                referrerValue = sessionStorage.getItem(this.referrerKey);
            }
            catch (e) {
                console.error(e);
            }
        }
        this.referrerValue = referrerValue ? referrerValue : '';
        try {
            sessionStorage.setItem(this.referrerKey, this.referrerValue);
        }
        catch (e) {
            console.error(e);
        }
        this.referrerSubject.next(this.referrerValue);
    }
}
ReferrerService.ɵfac = function ReferrerService_Factory(t) { return new (t || ReferrerService)(); };
ReferrerService.ɵprov = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjectable({ token: ReferrerService, factory: ReferrerService.ɵfac });
/** @nocollapse */
ReferrerService.ctorParameters = () => [];
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(ReferrerService, [{
        type: Injectable
    }], function () { return []; }, null); })();
if (false) {
    /** @type {?} */
    ReferrerService.prototype.referrer;
    /**
     * @type {?}
     * @private
     */
    ReferrerService.prototype.referrerValue;
    /**
     * @type {?}
     * @private
     */
    ReferrerService.prototype.referrerSubject;
    /**
     * @type {?}
     * @private
     */
    ReferrerService.prototype.referrerKey;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/route-handlers/hotjar/hot-jar.service.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class HotJarService {
    constructor() {
        //Handles case if HJ not loaded yet
        window.hj = window.hj || (/**
         * @return {?}
         */
        function () { (hj.q = hj.q || []).push(arguments); });
    }
    /**
     * @param {?} evtName
     * @param {?} evt
     * @return {?}
     */
    triggerEvent(evtName, evt) {
        window.hj(evtName, evt);
    }
}
HotJarService.ɵfac = function HotJarService_Factory(t) { return new (t || HotJarService)(); };
HotJarService.ɵprov = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjectable({ token: HotJarService, factory: HotJarService.ɵfac, providedIn: 'root' });
/** @nocollapse */
HotJarService.ctorParameters = () => [];
/** @nocollapse */ HotJarService.ngInjectableDef = ɵɵdefineInjectable({ factory: function HotJarService_Factory() { return new HotJarService(); }, token: HotJarService, providedIn: "root" });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(HotJarService, [{
        type: Injectable,
        args: [{ providedIn: 'root' }]
    }], function () { return []; }, null); })();

/**
 * @fileoverview added by tsickle
 * Generated from: lib/route-handlers/hotjar/hot-jar.directive.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class HotjarDirective {
    /**
     * @param {?} router
     * @param {?} service
     */
    constructor(router, service) {
        this.router = router;
        this.service = service;
        this.notPresentQuery = `ui-loading-spinner, .if-cloak`;
        this.waitTime = 250;
    }
    /**
     * @return {?}
     */
    ngOnInit() {
        this.evtSubscription = this.router.events.pipe(filter((/**
         * @param {?} evt
         * @return {?}
         */
        evt => evt instanceof NavigationEnd))).subscribe((/**
         * @param {?} evt
         * @return {?}
         */
        (evt) => {
            this.route = evt.urlAfterRedirects;
        }));
    }
    /**
     * @return {?}
     */
    ngAfterViewChecked() {
        if (this.route && !document.querySelector(this.notPresentQuery)) {
            /** @type {?} */
            const route = this.route;
            this.route = undefined;
            setTimeout((/**
             * @return {?}
             */
            () => {
                this.service.triggerEvent('stateChange', route);
            }), this.waitTime);
        }
    }
    /**
     * @return {?}
     */
    ngOnDestroy() {
        if (this.evtSubscription) {
            this.evtSubscription.unsubscribe();
        }
    }
}
HotjarDirective.ɵfac = function HotjarDirective_Factory(t) { return new (t || HotjarDirective)(ɵngcc0.ɵɵdirectiveInject(ɵngcc1.Router), ɵngcc0.ɵɵdirectiveInject(HotJarService)); };
HotjarDirective.ɵdir = /*@__PURE__*/ ɵngcc0.ɵɵdefineDirective({ type: HotjarDirective, selectors: [["", "ifHotJar", ""]], inputs: { notPresentQuery: "notPresentQuery", waitTime: "waitTime" } });
/** @nocollapse */
HotjarDirective.ctorParameters = () => [
    { type: Router },
    { type: HotJarService }
];
HotjarDirective.propDecorators = {
    notPresentQuery: [{ type: Input }],
    waitTime: [{ type: Input }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(HotjarDirective, [{
        type: Directive,
        args: [{
                selector: '[ifHotJar]'
            }]
    }], function () { return [{ type: ɵngcc1.Router }, { type: HotJarService }]; }, { notPresentQuery: [{
            type: Input
        }], waitTime: [{
            type: Input
        }] }); })();
if (false) {
    /** @type {?} */
    HotjarDirective.prototype.notPresentQuery;
    /** @type {?} */
    HotjarDirective.prototype.waitTime;
    /** @type {?} */
    HotjarDirective.prototype.route;
    /**
     * @type {?}
     * @private
     */
    HotjarDirective.prototype.evtSubscription;
    /**
     * @type {?}
     * @private
     */
    HotjarDirective.prototype.router;
    /**
     * @type {?}
     * @private
     */
    HotjarDirective.prototype.service;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/last-response/last-response.service.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class LastResponseService {
    constructor() {
        this.ifResponseSubject = new BehaviorSubject(this.ifResponse);
        this.ifResponseObservable = this.ifResponseSubject.asObservable();
    }
    /**
     * @return {?}
     */
    get ifResponse() {
        return this._ifResponse;
    }
    /**
     * @param {?} ifr
     * @return {?}
     */
    set ifResponse(ifr) {
        this._ifResponse = ifr;
        this.ifResponseSubject.next(this._ifResponse);
    }
    /**
     * @return {?}
     */
    getReferringTarget() {
        if (!this.ifResponse || !this.ifResponse.referrer) {
            return;
        }
        return this.ifResponse.referrer.target;
    }
    /**
     * @return {?}
     */
    clear() {
        this.ifResponse = undefined;
        this.bodyParams = undefined;
        this.lastRequest = undefined;
    }
}
LastResponseService.ɵfac = function LastResponseService_Factory(t) { return new (t || LastResponseService)(); };
LastResponseService.ɵprov = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjectable({ token: LastResponseService, factory: LastResponseService.ɵfac });
/** @nocollapse */
LastResponseService.ctorParameters = () => [];
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(LastResponseService, [{
        type: Injectable
    }], function () { return []; }, null); })();
if (false) {
    /**
     * @type {?}
     * @private
     */
    LastResponseService.prototype._ifResponse;
    /** @type {?} */
    LastResponseService.prototype.ifResponseObservable;
    /**
     * @type {?}
     * @private
     */
    LastResponseService.prototype.ifResponseSubject;
    /** @type {?} */
    LastResponseService.prototype.bodyParams;
    /** @type {?} */
    LastResponseService.prototype.lastRequest;
}
/**
 * @record
 */
function LastRequest() { }
if (false) {
    /** @type {?} */
    LastRequest.prototype.url;
    /** @type {?} */
    LastRequest.prototype.request;
    /** @type {?|undefined} */
    LastRequest.prototype.followProposedRoute;
    /** @type {?|undefined} */
    LastRequest.prototype.notifyTransition;
    /** @type {?} */
    LastRequest.prototype.mode;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/customer/customer.service.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class CustomerService {
    constructor() {
        this.properties = new Map();
        this.changeSubject = new Subject();
        this.change = this.changeSubject.asObservable();
    }
    /**
     * @param {?} name
     * @param {?} value
     * @return {?}
     */
    setProperty(name, value) {
        this.properties.set(name, value);
        this.changeSubject.next({ name, value });
    }
    /**
     * @param {?} props
     * @return {?}
     */
    setProperties(props) {
        props.forEach((/**
         * @param {?} prop
         * @return {?}
         */
        (prop) => {
            this.properties.set(prop.name, prop.value);
        }));
        this.changeSubject.next(props);
    }
    /**
     * @param {?} name
     * @return {?}
     */
    getProperty(name) {
        if (this.properties.has(name)) {
            return this.properties.get(name);
        }
    }
}
CustomerService.ɵfac = function CustomerService_Factory(t) { return new (t || CustomerService)(); };
CustomerService.ɵprov = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjectable({ token: CustomerService, factory: CustomerService.ɵfac });
/** @nocollapse */
CustomerService.ctorParameters = () => [];
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(CustomerService, [{
        type: Injectable
    }], function () { return []; }, null); })();
if (false) {
    /** @type {?} */
    CustomerService.prototype.change;
    /**
     * @type {?}
     * @private
     */
    CustomerService.prototype.properties;
    /**
     * @type {?}
     * @private
     */
    CustomerService.prototype.changeSubject;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/route-handlers/route-override/route-override.service.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * @record
 */
function IOverRideRoute() { }
if (false) {
    /** @type {?} */
    IOverRideRoute.prototype.useReferrer;
    /** @type {?} */
    IOverRideRoute.prototype.route;
    /** @type {?} */
    IOverRideRoute.prototype.override;
    /** @type {?|undefined} */
    IOverRideRoute.prototype.referrer;
}
class RouteOverrideService {
    /**
     * @param {?} customerService
     * @param {?} router
     * @param {?} route
     * @param {?} referrerService
     */
    constructor(customerService, router, route, referrerService) {
        this.customerService = customerService;
        this.router = router;
        this.route = route;
        this.referrerService = referrerService;
        this.overrideSubject = new Subject();
        this.routeOverriden = this.overrideSubject.asObservable();
        this.referrerService.referrer.subscribe((/**
         * @param {?} referrer
         * @return {?}
         */
        referrer => (this.referrer = referrer)));
        this.route.queryParams.subscribe((/**
         * @param {?} params
         * @return {?}
         */
        params => {
            if (!this.params) {
                this.params = params;
            }
            else {
                Object.keys(params).map((/**
                 * @param {?} index
                 * @return {?}
                 */
                index => {
                    if (!this.params[index]) {
                        this.params[index] = params[index];
                    }
                }));
            }
        }));
        this.router.events.subscribe((/**
         * @param {?} evt
         * @return {?}
         */
        (evt) => {
            if (evt instanceof NavigationStart) {
                this.overrides = this.customerService.getProperty(RouteOverrideService.ROUTE_OVERRIDE_KEY);
                if (this.overrides === undefined) {
                    this.customerService.change.subscribe((/**
                     * @param {?} obj
                     * @return {?}
                     */
                    obj => {
                        if (!Array.isArray(obj) && obj.name === RouteOverrideService.ROUTE_OVERRIDE_KEY) {
                            this.overrides = (/** @type {?} */ (obj.value));
                            this.checkRoute(evt.url, this.overrides);
                        }
                    }));
                }
                else {
                    this.checkRoute(evt.url, this.overrides);
                }
            }
        }));
    }
    /**
     * @private
     * @param {?} url
     * @param {?} overrides
     * @return {?}
     */
    checkRoute(url, overrides) {
        if (overrides.length) {
            /** @type {?} */
            const routeUrl = url.indexOf('?') > -1 ? url.substring(0, url.indexOf('?')) : url;
            /** @type {?} */
            let replacement;
            /** @type {?} */
            const matched = overrides.some((/**
             * @param {?} ifr
             * @return {?}
             */
            (ifr) => {
                this.applyPathToRoute(routeUrl, ifr.route);
                /** @type {?} */
                let testRoute = this.applyParamsToRoute(ifr.route);
                if (routeUrl === testRoute) {
                    /** @type {?} */
                    let override = '';
                    if (Array.isArray(ifr.override)) {
                        ifr.override.forEach((/**
                         * @param {?} or
                         * @return {?}
                         */
                        or => {
                            if (document.location.hostname.indexOf(or.host) > -1) {
                                override = or.route;
                            }
                        }));
                    }
                    else {
                        override = ifr.override;
                    }
                    if (!ifr.useReferrer || !this.referrer) {
                        /** @type {?} */
                        const overrideRoute = this.applyParamsToRoute(override);
                        replacement = overrideRoute;
                        document.location.href = overrideRoute;
                    }
                    else {
                        if (ifr.referrer && ifr.referrer.replace) {
                            replacement = this.referrer;
                            document.location.href = this.referrer;
                        }
                        else {
                            if (ifr.referrer && ifr.referrer.pattern) {
                                /** @type {?} */
                                let pattern = ifr.referrer.pattern;
                                if (typeof pattern === 'string') {
                                    pattern = new RegExp(pattern);
                                }
                                /** @type {?} */
                                const replace = this.referrer.match(pattern);
                                if (replace && replace[0]) {
                                    /** @type {?} */
                                    let newRoute = override.replace(pattern, replace[0]);
                                    newRoute = this.applyParamsToRoute(newRoute);
                                    replacement = newRoute;
                                    document.location.href = newRoute;
                                }
                            }
                        }
                    }
                    return true;
                }
                return false;
            }));
            this.overrideSubject.next({ matched, replacement });
        }
    }
    /**
     * @private
     * @param {?} route
     * @return {?}
     */
    applyParamsToRoute(route) {
        /** @type {?} */
        let tmpRoute = route;
        if (this.params) {
            Object.keys(this.params).forEach((/**
             * @param {?} key
             * @return {?}
             */
            key => {
                tmpRoute = tmpRoute.replace(`__${key}__`, this.params[key]);
            }));
        }
        return tmpRoute;
    }
    /**
     * @private
     * @param {?} url
     * @param {?} route
     * @return {?}
     */
    applyPathToRoute(url, route) {
        if (/__(.*?)__/.test(route)) {
            /** @type {?} */
            let routeKeys = route.match(/__(.*?)__/g).map((/**
             * @param {?} key
             * @return {?}
             */
            key => key.replace(/^[_]+|[_]+$/g, "")));
            /** @type {?} */
            let routeRegex = route.replace(/__(.*?)__/g, '(.*)');
            /** @type {?} */
            let routeValues = [];
            /** @type {?} */
            let matches = url.match(routeRegex);
            if (matches) {
                matches.forEach((/**
                 * @param {?} match
                 * @param {?} index
                 * @return {?}
                 */
                (match, index) => {
                    if (index > 0) {
                        routeValues.push(match);
                    }
                }));
                if (routeKeys && routeValues.length === routeKeys.length) {
                    routeKeys.forEach((/**
                     * @param {?} key
                     * @param {?} index
                     * @return {?}
                     */
                    (key, index) => {
                        if (!this.params[key]) {
                            this.params[key] = routeValues[index];
                        }
                    }));
                }
            }
        }
    }
}
RouteOverrideService.ɵfac = function RouteOverrideService_Factory(t) { return new (t || RouteOverrideService)(ɵngcc0.ɵɵinject(CustomerService), ɵngcc0.ɵɵinject(ɵngcc1.Router), ɵngcc0.ɵɵinject(ɵngcc1.ActivatedRoute), ɵngcc0.ɵɵinject(ReferrerService)); };
RouteOverrideService.ɵprov = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjectable({ token: RouteOverrideService, factory: RouteOverrideService.ɵfac });
RouteOverrideService.ROUTE_OVERRIDE_KEY = 'RouteOverrides';
/** @nocollapse */
RouteOverrideService.ctorParameters = () => [
    { type: CustomerService },
    { type: Router },
    { type: ActivatedRoute },
    { type: ReferrerService }
];
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(RouteOverrideService, [{
        type: Injectable
    }], function () { return [{ type: CustomerService }, { type: ɵngcc1.Router }, { type: ɵngcc1.ActivatedRoute }, { type: ReferrerService }]; }, null); })();
if (false) {
    /** @type {?} */
    RouteOverrideService.ROUTE_OVERRIDE_KEY;
    /** @type {?} */
    RouteOverrideService.prototype.routeOverriden;
    /**
     * @type {?}
     * @private
     */
    RouteOverrideService.prototype.overrideSubject;
    /**
     * @type {?}
     * @private
     */
    RouteOverrideService.prototype.referrer;
    /**
     * @type {?}
     * @private
     */
    RouteOverrideService.prototype.params;
    /**
     * @type {?}
     * @private
     */
    RouteOverrideService.prototype.overrides;
    /**
     * @type {?}
     * @private
     */
    RouteOverrideService.prototype.customerService;
    /**
     * @type {?}
     * @private
     */
    RouteOverrideService.prototype.router;
    /**
     * @type {?}
     * @private
     */
    RouteOverrideService.prototype.route;
    /**
     * @type {?}
     * @private
     */
    RouteOverrideService.prototype.referrerService;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/params-service/params.service.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class ParamsService {
    constructor() {
        this.index = 0;
    }
    /**
     * @param {?} key
     * @return {?}
     */
    static removeUniquePrefix(key) {
        return key.replace(ParamsService.pattern, '');
    }
    // needed to force checkboxes to have unique names
    /**
     * @param {?} key
     * @return {?}
     */
    addUniquePrefix(key) {
        this.index++;
        if (this.index > 9999) {
            this.index = 0;
        }
        return `MAKE_UNIQUE_${this.index}_${key}`;
    }
}
ParamsService.ɵfac = function ParamsService_Factory(t) { return new (t || ParamsService)(); };
ParamsService.ɵprov = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjectable({ token: ParamsService, factory: ParamsService.ɵfac, providedIn: 'root' });
// new RegExp adds the / / to the string e.g., new RegExp('MAKE_UNIQUE_\\d+_') => /MAKE_UNIQUE_\d+_/
ParamsService.pattern = new RegExp('MAKE_UNIQUE_\\d+_');
/** @nocollapse */
ParamsService.ctorParameters = () => [];
/** @nocollapse */ ParamsService.ngInjectableDef = ɵɵdefineInjectable({ factory: function ParamsService_Factory() { return new ParamsService(); }, token: ParamsService, providedIn: "root" });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(ParamsService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return []; }, null); })();
if (false) {
    /** @type {?} */
    ParamsService.pattern;
    /** @type {?} */
    ParamsService.prototype.index;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/core-ng-options.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * @record
 */
function ICoreNgOptions() { }
if (false) {
    /** @type {?|undefined} */
    ICoreNgOptions.prototype.navigateToActiveRoute;
    /** @type {?} */
    ICoreNgOptions.prototype.maxValidRequestsPerPage;
    /** @type {?} */
    ICoreNgOptions.prototype.maxInvalidRequestsPerPage;
    /** @type {?} */
    ICoreNgOptions.prototype.genericErrorRoute;
}
class CoreNgOptions {
    /**
     * @param {?} _navigateToActiveRoute
     * @param {?=} _maxValidRequestsPerPage
     * @param {?=} _maxInvalidRequestsPerPage
     * @param {?=} _genericErrorRoute
     */
    constructor(_navigateToActiveRoute, _maxValidRequestsPerPage = 1000, _maxInvalidRequestsPerPage = 30, _genericErrorRoute = '/error') {
        this._navigateToActiveRoute = _navigateToActiveRoute;
        this._maxValidRequestsPerPage = _maxValidRequestsPerPage;
        this._maxInvalidRequestsPerPage = _maxInvalidRequestsPerPage;
        this._genericErrorRoute = _genericErrorRoute;
    }
    /**
     * @return {?}
     */
    get navigateToActiveRoute() {
        return this._navigateToActiveRoute;
    }
    /**
     * @return {?}
     */
    get maxValidRequestsPerPage() {
        return this._maxValidRequestsPerPage;
    }
    /**
     * @return {?}
     */
    get maxInvalidRequestsPerPage() {
        return this._maxInvalidRequestsPerPage;
    }
    /**
     * @return {?}
     */
    get genericErrorRoute() {
        return this._genericErrorRoute;
    }
    /**
     * @param {?} requests
     * @return {?}
     */
    set maxValidRequestsPerPage(requests) {
        this._maxValidRequestsPerPage = requests;
    }
    /**
     * @param {?} requests
     * @return {?}
     */
    set maxInvalidRequestsPerPage(requests) {
        this._maxInvalidRequestsPerPage = requests;
    }
    /**
     * @param {?} route
     * @return {?}
     */
    set genericErrorRoute(route) {
        this._genericErrorRoute = route;
    }
}
if (false) {
    /**
     * @type {?}
     * @private
     */
    CoreNgOptions.prototype._navigateToActiveRoute;
    /**
     * @type {?}
     * @private
     */
    CoreNgOptions.prototype._maxValidRequestsPerPage;
    /**
     * @type {?}
     * @private
     */
    CoreNgOptions.prototype._maxInvalidRequestsPerPage;
    /**
     * @type {?}
     * @private
     */
    CoreNgOptions.prototype._genericErrorRoute;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/http/http.service.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
// tslint:disable-next-line:max-classes-per-file
/**
 * @abstract
 */
class HttpEvent {
    constructor() {
        this.notify = true;
    }
}
if (false) {
    /** @type {?} */
    HttpEvent.prototype.notify;
}
// tslint:disable-next-line:max-classes-per-file
class StartHttpEvent extends HttpEvent {
    /**
     * @param {?} notify
     */
    constructor(notify) {
        super();
        this.notify = notify;
    }
}
// tslint:disable-next-line:max-classes-per-file
class EndHttpEvent extends HttpEvent {
    /**
     * @param {?} notify
     */
    constructor(notify) {
        super();
        this.notify = notify;
    }
}
// tslint:disable-next-line:max-classes-per-file
class ErrorHttpEvent extends HttpEvent {
    /**
     * @param {?} proposedTemplate
     * @param {?} error
     */
    constructor(proposedTemplate, error) {
        super();
        this.error = error;
        this.proposedTemplate = proposedTemplate;
    }
}
if (false) {
    /** @type {?} */
    ErrorHttpEvent.prototype.proposedTemplate;
    /** @type {?} */
    ErrorHttpEvent.prototype.error;
}
class Http {
    /**
     * @param {?} router
     * @param {?} lastService
     * @param {?=} coreNgOptions
     */
    constructor(router, lastService, coreNgOptions) {
        this.coreNgOptions = coreNgOptions;
        this.validRequestsPerPage = 0;
        this.invalidRequestsPerPage = 0;
        this.router = router;
        this.lastService = lastService;
        this.httpEventsSubject = new Subject();
        this.httpEvents = this.httpEventsSubject.asObservable();
        this.router.events.pipe(filter((/**
         * @param {?} event
         * @return {?}
         */
        event => event instanceof NavigationStart))).subscribe((/**
         * @param {?} event
         * @return {?}
         */
        (event) => {
            if (event.url && event.url.indexOf(this.coreNgOptions.genericErrorRoute) < 0) {
                this.resetRequestsAllowance();
            }
        }));
    }
    /**
     * @private
     * @return {?}
     */
    resetRequestsAllowance() {
        this.validRequestsPerPage = 0;
        this.hasInvalidRequest = false;
    }
    /**
     * @private
     * @return {?}
     */
    resetInvalidRequestsAllowance() {
        this.invalidRequestsPerPage = 0;
    }
    /**
     * @return {?}
     */
    handleRequestAllowance() {
        if ((this.invalidRequestsPerPage < this.coreNgOptions.maxInvalidRequestsPerPage || !this.hasInvalidRequest) && (this.validRequestsPerPage < this.coreNgOptions.maxValidRequestsPerPage)) {
            return true;
        }
        this.router.navigate([this.coreNgOptions.genericErrorRoute]);
        return false;
    }
    /**
     * @private
     * @param {?} status
     * @return {?}
     */
    updateValidRequestAllowance(status) {
        if (!status || (typeof status === "number" && status < 400)) {
            this.validRequestsPerPage++;
            this.resetInvalidRequestsAllowance();
        }
        else {
            return this.updateInvalidRequestAllowance();
        }
        return this.handleRequestAllowance();
    }
    /**
     * @private
     * @return {?}
     */
    updateInvalidRequestAllowance() {
        this.invalidRequestsPerPage++;
        this.hasInvalidRequest = true;
        return this.handleRequestAllowance();
    }
    /**
     * @param {?} url
     * @param {?} form
     * @param {?=} followProposedRoute
     * @param {?=} notifyTransition
     * @return {?}
     */
    postForm(url, form, followProposedRoute = true, notifyTransition = true) {
        return __awaiter(this, void 0, void 0, function* () {
            this.httpEventsSubject.next(new StartHttpEvent(notifyTransition));
            if (form && form instanceof FormData) {
                return this.postFormData(url, form, followProposedRoute, notifyTransition);
            }
            else {
                /** @type {?} */
                const body = new Params();
                if (form && (form instanceof NgForm || form instanceof FormGroup) && form.controls) {
                    Object.keys(form.value).forEach((/**
                     * @param {?} key
                     * @return {?}
                     */
                    key => {
                        if (form.value[key] !== null && form.value[key] !== undefined && !Array.isArray(form.controls[key]['controls'])) {
                            body.set(key, form.value[key]);
                        }
                    }));
                    if (form instanceof FormGroup) {
                        Object.keys(form.controls).forEach((/**
                         * @param {?} key
                         * @return {?}
                         */
                        key => {
                            if (Array.isArray(form.controls[key]['controls'])) {
                                form.controls[key]['controls'].forEach((/**
                                 * @param {?} c
                                 * @return {?}
                                 */
                                c => {
                                    if (c.value) {
                                        body.set(key, c.value);
                                    }
                                }));
                            }
                        }));
                    }
                }
                return this.post(url, body, RequestMode.InFlight, followProposedRoute, notifyTransition);
            }
        });
    }
    /**
     * @param {?} url
     * @param {?} form
     * @param {?=} followProposedRoute
     * @param {?=} notifyTransition
     * @return {?}
     */
    postFormData(url, form, followProposedRoute = true, notifyTransition = true) {
        return __awaiter(this, void 0, void 0, function* () {
            return this.post(url, form, RequestMode.InFlight, followProposedRoute, notifyTransition, undefined);
        });
    }
    /**
     * @param {?} url
     * @param {?} bodyParams
     * @param {?=} mode
     * @param {?=} followProposedRoute
     * @param {?=} notifyTransition
     * @param {?=} searchParams
     * @return {?}
     */
    post(url, bodyParams, mode = RequestMode.InFlight, followProposedRoute = true, notifyTransition = true, searchParams) {
        return __awaiter(this, void 0, void 0, function* () {
            this.httpEventsSubject.next(new StartHttpEvent(notifyTransition));
            /** @type {?} */
            let URL = url;
            if (searchParams) {
                URL = url.indexOf('?') > -1 ? `${url}&${searchParams.toString()}` : `${url}?${searchParams.toString()}`;
            }
            this.lastService.bodyParams = bodyParams instanceof FormData ? undefined : bodyParams;
            if (this.handleRequestAllowance()) {
                if (mode === RequestMode.InFlight) {
                    return Http$1.post(URL, bodyParams, RequestMode.InFlight)
                        .then((/**
                     * @param {?} res
                     * @return {?}
                     */
                    (res) => this.populateLastResponse(res)))
                        .then((/**
                     * @param {?} res
                     * @return {?}
                     */
                    (res) => this.processIFResponse(res, followProposedRoute, notifyTransition)))
                        .then((/**
                     * @param {?} res
                     * @return {?}
                     */
                    (res) => {
                        this.updateValidRequestAllowance(res.status);
                        return res;
                    }))
                        .catch((/**
                     * @param {?} e
                     * @return {?}
                     */
                    (e) => {
                        this.updateInvalidRequestAllowance();
                        this.dispatchError(e);
                    }));
                }
                else {
                    return Http$1.post(URL, bodyParams, RequestMode.Raw)
                        .then((/**
                     * @param {?} res
                     * @return {?}
                     */
                    (res) => {
                        this.updateValidRequestAllowance(res.status);
                        return res;
                    }))
                        .catch((/**
                     * @param {?} e
                     * @return {?}
                     */
                    (e) => {
                        this.updateInvalidRequestAllowance();
                        this.dispatchError(e);
                    }));
                }
            }
        });
    }
    /**
     * @param {?} url
     * @param {?} searchParams
     * @param {?} mode
     * @param {?=} followProposedRoute
     * @param {?=} notifyTransition
     * @return {?}
     */
    get(url, searchParams, mode, followProposedRoute = true, notifyTransition = true) {
        return __awaiter(this, void 0, void 0, function* () {
            this.httpEventsSubject.next(new StartHttpEvent(notifyTransition));
            /** @type {?} */
            let updatedURL = url;
            if (searchParams && searchParams.toString().trim()) {
                /** @type {?} */
                const urlParts = url.split('?');
                /** @type {?} */
                let params = searchParams;
                if (urlParts[1]) {
                    params = new URLSearchParams(urlParts[1]);
                    searchParams.forEach((/**
                     * @param {?} v
                     * @param {?} k
                     * @return {?}
                     */
                    (v, k) => {
                        if (params.has(k)) {
                            params.set(k, v);
                        }
                        else {
                            params.append(k, v);
                        }
                    }));
                }
                updatedURL = `${urlParts[0]}?${params.toString()}`;
            }
            if (this.handleRequestAllowance()) {
                if (mode === RequestMode.InFlight) {
                    try {
                        /** @type {?} */
                        let response = (/** @type {?} */ ((yield Http$1.get(updatedURL, RequestMode.InFlight))));
                        if (response) {
                            response = yield this.populateLastResponse(response);
                            response = yield this.processIFResponse(response, followProposedRoute, notifyTransition);
                            this.updateValidRequestAllowance(response.status);
                            return response;
                        }
                    }
                    catch (e) {
                        this.updateInvalidRequestAllowance();
                        this.dispatchError(e);
                    }
                }
                else {
                    try {
                        /** @type {?} */
                        const response = (/** @type {?} */ ((yield Http$1.get(updatedURL, RequestMode.Raw))));
                        if (response) {
                            this.updateValidRequestAllowance(response.status);
                            return response;
                        }
                    }
                    catch (e) {
                        this.dispatchError(e);
                        this.updateInvalidRequestAllowance();
                    }
                }
            }
        });
    }
    /**
     * @return {?}
     */
    retryLastRequest() {
        if (this.lastService.lastRequest) {
            if (this.lastService.lastRequest.mode === RequestMode.InFlight) {
                return this.fetch(this.lastService.lastRequest.url, this.lastService.lastRequest.request, this.lastService.lastRequest.mode)
                    .then((/**
                 * @param {?} res
                 * @return {?}
                 */
                (res) => this.populateLastResponse(res)))
                    .then((/**
                 * @param {?} res
                 * @return {?}
                 */
                (res) => this.processIFResponse(res, !!this.lastService.lastRequest.followProposedRoute, !!this.lastService.lastRequest.notifyTransition)))
                    .catch((/**
                 * @param {?} e
                 * @return {?}
                 */
                (e) => {
                    this.dispatchError(e);
                }));
            }
            else {
                return this.fetch(this.lastService.lastRequest.url, this.lastService.lastRequest.request, this.lastService.lastRequest.mode)
                    .catch((/**
                 * @param {?} e
                 * @return {?}
                 */
                (e) => {
                    this.dispatchError(e);
                }));
            }
        }
    }
    /**
     * @param {?} url
     * @param {?} request
     * @param {?} mode
     * @return {?}
     */
    fetch(url, request, mode) {
        return __awaiter(this, void 0, void 0, function* () {
            return Http$1.fetch(url, request, mode)
                .then((/**
             * @param {?} res
             * @return {?}
             */
            (res) => {
                this.updateValidRequestAllowance(res.status);
                return res;
            }))
                .catch((/**
             * @param {?} e
             * @return {?}
             */
            (e) => {
                this.updateInvalidRequestAllowance();
            }));
        });
    }
    /**
     * @private
     * @param {?} error
     * @return {?}
     */
    dispatchError(error) {
        if (error && error.lastRequest) {
            return this.networkErrorHandler(error);
        }
        return this.handleError(error);
    }
    /**
     * @private
     * @param {?} error
     * @return {?}
     */
    networkErrorHandler(error) {
        this.lastService.lastRequest = error.lastRequest;
        this.httpEventsSubject.next(new ErrorHttpEvent('/error/network', error));
        this.logError(error);
    }
    /**
     * @private
     * @param {?} error
     * @return {?}
     */
    handleError(error) {
        this.httpEventsSubject.next(new ErrorHttpEvent('/error', error));
        this.logError(error);
    }
    /**
     * @private
     * @param {?} error
     * @return {?}
     */
    logError(error) {
        /** @type {?} */
        let errMsg;
        if (error instanceof Response) {
            /** @type {?} */
            const body = error.json() || '';
            /** @type {?} */
            const err = JSON.stringify(body);
            errMsg = `${error.status} - ${error.statusText || ''} ${err}`;
        }
        else {
            errMsg = error.message ? error.message : error.toString();
        }
        console.error(errMsg);
    }
    /**
     * @private
     * @param {?} res
     * @return {?}
     */
    populateLastResponse(res) {
        return __awaiter(this, void 0, void 0, function* () {
            this.lastService.ifResponse = res;
            return Promise.resolve(res);
        });
    }
    /**
     * @private
     * @param {?} res
     * @param {?} followProposedRoute
     * @param {?=} notifyTransition
     * @return {?}
     */
    processIFResponse(res, followProposedRoute, notifyTransition = true) {
        return __awaiter(this, void 0, void 0, function* () {
            this.httpEventsSubject.next(new EndHttpEvent(notifyTransition));
            if (followProposedRoute) {
                if (!res || !res.ProposedTemplate) {
                    this.router.navigate(['/']);
                }
                else {
                    /** @type {?} */
                    const navigateToActiveRoute = !this.coreNgOptions || !!this.coreNgOptions.navigateToActiveRoute;
                    if (navigateToActiveRoute || !this.router.isActive(res.ProposedTemplate, true)) {
                        this.router.navigate([res.ProposedTemplate], {
                            queryParamsHandling: 'merge'
                        });
                    }
                }
            }
            return Promise.resolve(res);
        });
    }
}
Http.ɵfac = function Http_Factory(t) { return new (t || Http)(ɵngcc0.ɵɵinject(ɵngcc1.Router), ɵngcc0.ɵɵinject(LastResponseService), ɵngcc0.ɵɵinject(CoreNgOptions)); };
Http.ɵprov = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjectable({ token: Http, factory: Http.ɵfac });
/** @nocollapse */
Http.ctorParameters = () => [
    { type: Router },
    { type: LastResponseService },
    { type: CoreNgOptions }
];
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(Http, [{
        type: Injectable
    }], function () { return [{ type: ɵngcc1.Router }, { type: LastResponseService }, { type: CoreNgOptions }]; }, null); })();
if (false) {
    /** @type {?} */
    Http.prototype.httpEvents;
    /**
     * @type {?}
     * @protected
     */
    Http.prototype.router;
    /**
     * @type {?}
     * @protected
     */
    Http.prototype.lastService;
    /**
     * @type {?}
     * @protected
     */
    Http.prototype.httpEventsSubject;
    /**
     * @type {?}
     * @protected
     */
    Http.prototype.validRequestsPerPage;
    /**
     * @type {?}
     * @protected
     */
    Http.prototype.invalidRequestsPerPage;
    /**
     * @type {?}
     * @protected
     */
    Http.prototype.hasInvalidRequest;
    /**
     * @type {?}
     * @private
     */
    Http.prototype.coreNgOptions;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/sign-out/sign-out.service.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class SignOutService {
    constructor() {
        this.signedOutClickedSubject = new Subject();
        this.hasSignOutSubject = new Subject();
        this.signOutEvent = this.signedOutClickedSubject.asObservable();
        this.signOut = this.hasSignOutSubject.asObservable();
    }
    /**
     * @param {?} signOut
     * @return {?}
     */
    triggerSignout(signOut) {
        this.signedOutClickedSubject.next(signOut);
    }
    /**
     * @param {?} signOut
     * @return {?}
     */
    setSignOut(signOut) {
        this.hasSignOutSubject.next(signOut);
    }
}
SignOutService.ɵfac = function SignOutService_Factory(t) { return new (t || SignOutService)(); };
SignOutService.ɵprov = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjectable({ token: SignOutService, factory: SignOutService.ɵfac });
/** @nocollapse */
SignOutService.ctorParameters = () => [];
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(SignOutService, [{
        type: Injectable
    }], function () { return []; }, null); })();
if (false) {
    /** @type {?} */
    SignOutService.prototype.signOut;
    /** @type {?} */
    SignOutService.prototype.signOutEvent;
    /**
     * @type {?}
     * @private
     */
    SignOutService.prototype.signedOutClickedSubject;
    /**
     * @type {?}
     * @private
     */
    SignOutService.prototype.hasSignOutSubject;
}
/**
 * @record
 */
function ISignOut() { }
if (false) {
    /** @type {?} */
    ISignOut.prototype.label;
    /** @type {?} */
    ISignOut.prototype.id;
    /** @type {?} */
    ISignOut.prototype.name;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/route-handlers/google/google-tag-manager.service.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class GoogleTagManagerService {
    /**
     * @param {?} settings
     * @param {?} router
     * @param {?} optimize
     */
    constructor(settings, router, optimize) {
        this.settings = settings;
        this.router = router;
        this.optimize = optimize;
        this.router.events.subscribe((/**
         * @param {?} event
         * @return {?}
         */
        (event) => {
            if (event instanceof NavigationEnd && window.dataLayer && event.urlAfterRedirects) {
                /** @type {?} */
                const url = event.urlAfterRedirects.split('?')[0];
                window.dataLayer.push({
                    page: url,
                    event: 'pageview'
                });
            }
        }));
        this.initialize(this.settings.googleTagManager);
    }
    /**
     * @param {?} googleTagManager
     * @param {?=} force
     * @return {?}
     */
    initialize(googleTagManager, force = false) {
        if ((googleTagManager && !window.dataLayer) || (googleTagManager && force)) {
            this.initalizeTagManager(googleTagManager);
            this.insertTagManagerIframe(googleTagManager);
        }
    }
    /**
     * @param {?} obj
     * @return {?}
     */
    push(obj) {
        if (!window.dataLayer) {
            window.dataLayer = [];
        }
        window.dataLayer.push(obj);
        this.optimize.triggerOptimize();
    }
    /**
     * @private
     * @param {?} googleTagCode
     * @return {?}
     */
    initalizeTagManager(googleTagCode) {
        /** @type {?} */
        const script = (/** @type {?} */ (document.createElement('script')));
        script.innerHTML = `(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
      new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
      j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
      'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
      })(window,document,'script','dataLayer','${googleTagCode}')`;
        document.head.appendChild(script);
    }
    /**
     * @private
     * @param {?} googleTagCode
     * @return {?}
     */
    insertTagManagerIframe(googleTagCode) {
        /** @type {?} */
        const hasFrame = document.querySelector(`iframe[src*='${googleTagCode}']`);
        if (!hasFrame) {
            /** @type {?} */
            const noscript = document.createElement('noscript');
            /** @type {?} */
            const iframe = document.createElement('iframe');
            iframe.height = '0';
            iframe.width = '0';
            iframe.setAttribute('style', 'display:none;visibility:hidden');
            iframe.src = `https://www.googletagmanager.com/ns.html?id=${googleTagCode}`;
            noscript.appendChild(iframe);
            document.body.insertBefore(noscript, document.body.children[0]);
        }
    }
}
GoogleTagManagerService.ɵfac = function GoogleTagManagerService_Factory(t) { return new (t || GoogleTagManagerService)(ɵngcc0.ɵɵinject(SettingsService), ɵngcc0.ɵɵinject(ɵngcc1.Router), ɵngcc0.ɵɵinject(GoogleOptimizeService)); };
GoogleTagManagerService.ɵprov = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjectable({ token: GoogleTagManagerService, factory: GoogleTagManagerService.ɵfac });
/** @nocollapse */
GoogleTagManagerService.ctorParameters = () => [
    { type: SettingsService },
    { type: Router },
    { type: GoogleOptimizeService }
];
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(GoogleTagManagerService, [{
        type: Injectable
    }], function () { return [{ type: SettingsService }, { type: ɵngcc1.Router }, { type: GoogleOptimizeService }]; }, null); })();
if (false) {
    /**
     * @type {?}
     * @private
     */
    GoogleTagManagerService.prototype.settings;
    /**
     * @type {?}
     * @private
     */
    GoogleTagManagerService.prototype.router;
    /**
     * @type {?}
     * @private
     */
    GoogleTagManagerService.prototype.optimize;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/app-injector/app-injector.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
//Use this to inject services into parent classes without modifying subclasses.
//Similar to https://stackoverflow.com/questions/39409328/storing-injector-instance-for-use-in-components
/** @type {?} */
let _appInjector;
class AppInjector {
    /**
     * @return {?}
     */
    static getInjector() {
        if (!_appInjector) {
            console.error("CoreNg: Attempt to use AppInjector before it was set.");
        }
        return _appInjector;
    }
    /**
     * @param {?} injector
     * @param {?=} override
     * @return {?}
     */
    static setInjector(injector, override) {
        if (_appInjector && !override) {
            console.warn("CoreNg: Attempt to set AppInjector more than once.");
            return;
        }
        _appInjector = injector;
    }
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/route-handlers/google/gtm.helper.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class GTMHelper {
    /**
     * @param {?} str
     * @return {?}
     */
    static hash(str) {
        return __awaiter(this, void 0, void 0, function* () {
            if (!window.crypto || !window.crypto.subtle || !window.crypto.subtle.digest) {
                return '';
            }
            /** @type {?} */
            const strBuffer = this.textEncode(str);
            /** @type {?} */
            const hashBuffer = yield crypto.subtle.digest('SHA-256', strBuffer);
            /** @type {?} */
            const hashArray = Array.from(new Uint8Array(hashBuffer));
            /** @type {?} */
            const hashHex = hashArray.map((/**
             * @param {?} b
             * @return {?}
             */
            b => ('00' + b.toString(16)).slice(-2))).join('');
            return hashHex;
        });
    }
    /**
     * @private
     * @param {?} str
     * @return {?}
     */
    static textEncode(str) {
        if (window.TextEncoder) {
            return new TextEncoder().encode(str);
        }
        /** @type {?} */
        const utf8 = window.unescape(encodeURIComponent(str));
        /** @type {?} */
        const result = new Uint8Array(utf8.length);
        for (let i = 0; i < utf8.length; i++) {
            result[i] = utf8.charCodeAt(i);
        }
        return result;
    }
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/hooks/event-arguments.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * @record
 */
function OnChangeEvent() { }
if (false) {
    /** @type {?} */
    OnChangeEvent.prototype.src;
    /** @type {?} */
    OnChangeEvent.prototype.args;
}
/**
 * @record
 */
function EventArguments() { }
if (false) {
    /** @type {?} */
    EventArguments.prototype.form;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/http/if-session.service.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class IfSessionService {
    /**
     * @param {?} settings
     */
    constructor(settings) {
        this.settings = settings;
    }
    /**
     * @param {?=} systemKey
     * @return {?}
     */
    initIFSession(systemKey) {
        return __awaiter(this, void 0, void 0, function* () {
            /** @type {?} */
            let settings = this.settings.defaultSystemSettings;
            if (systemKey) {
                settings = this.settings.getSystemSettings(systemKey);
            }
            /** @type {?} */
            let url;
            if (settings.IFInitSessionURL) {
                url = settings.IFInitSessionURL;
            }
            else {
                // this is for backwards compatibility
                url = `${settings.IFURLPrefix}/--IF/-/${settings.InFlightID}/-/GetInFlightSession/FI--`;
            }
            /** @type {?} */
            const response = (/** @type {?} */ ((yield Http$1.get(url, RequestMode.Raw))));
            return response.ok;
        });
    }
}
IfSessionService.ɵfac = function IfSessionService_Factory(t) { return new (t || IfSessionService)(ɵngcc0.ɵɵinject(SettingsService)); };
IfSessionService.ɵprov = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjectable({ token: IfSessionService, factory: IfSessionService.ɵfac, providedIn: 'root' });
/** @nocollapse */
IfSessionService.ctorParameters = () => [
    { type: SettingsService }
];
/** @nocollapse */ IfSessionService.ngInjectableDef = ɵɵdefineInjectable({ factory: function IfSessionService_Factory() { return new IfSessionService(ɵɵinject(SettingsService)); }, token: IfSessionService, providedIn: "root" });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(IfSessionService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return [{ type: SettingsService }]; }, null); })();
if (false) {
    /**
     * @type {?}
     * @private
     */
    IfSessionService.prototype.settings;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/pipes/if-date.pipe.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class IFDatePipe {
    constructor() { }
    /**
     * @param {?} value
     * @param {?=} params
     * @return {?}
     */
    transform(value, params) {
        try {
            /** @type {?} */
            let inputFormat = 'MM/DD/YYYY';
            if (params && params.locale && params.locale.dateFormat) {
                inputFormat = params.locale.dateFormat;
            }
            /** @type {?} */
            let outputFormat = 'MMM D, YYYY';
            if (params && params.format) {
                outputFormat = params.format;
            }
            /** @type {?} */
            const date = moment(value, inputFormat, true);
            if (date.isValid()) {
                return date.format(outputFormat);
            }
            return value;
        }
        catch (e) {
            console.error(`Error parsing date value '${value}'.`, e);
            return value;
        }
    }
}
IFDatePipe.ɵfac = function IFDatePipe_Factory(t) { return new (t || IFDatePipe)(); };
IFDatePipe.ɵpipe = /*@__PURE__*/ ɵngcc0.ɵɵdefinePipe({ name: "ifdate", type: IFDatePipe, pure: true });
/** @nocollapse */
IFDatePipe.ctorParameters = () => [];
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(IFDatePipe, [{
        type: Pipe,
        args: [{ name: 'ifdate' }]
    }], function () { return []; }, null); })();
class IFDatePipeParams {
}
if (false) {
    /** @type {?} */
    IFDatePipeParams.prototype.locale;
    /** @type {?} */
    IFDatePipeParams.prototype.format;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/analytics/if-personally-identifiable-information.directive.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class IfPersonallyIdentifiableInformationDirective {
    /**
     * @param {?} elementRef
     * @param {?} renderer
     */
    constructor(elementRef, renderer) {
        this.elementRef = elementRef;
        this.renderer = renderer;
    }
    /**
     * @return {?}
     */
    ngOnInit() {
        this.renderer.setAttribute(this.elementRef.nativeElement, 'data-hj-suppress', '');
    }
}
IfPersonallyIdentifiableInformationDirective.ɵfac = function IfPersonallyIdentifiableInformationDirective_Factory(t) { return new (t || IfPersonallyIdentifiableInformationDirective)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.Renderer2)); };
IfPersonallyIdentifiableInformationDirective.ɵdir = /*@__PURE__*/ ɵngcc0.ɵɵdefineDirective({ type: IfPersonallyIdentifiableInformationDirective, selectors: [["", "ifPII", ""]] });
/** @nocollapse */
IfPersonallyIdentifiableInformationDirective.ctorParameters = () => [
    { type: ElementRef },
    { type: Renderer2 }
];
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(IfPersonallyIdentifiableInformationDirective, [{
        type: Directive,
        args: [{
                selector: '[ifPII]'
            }]
    }], function () { return [{ type: ɵngcc0.ElementRef }, { type: ɵngcc0.Renderer2 }]; }, null); })();
if (false) {
    /**
     * @type {?}
     * @private
     */
    IfPersonallyIdentifiableInformationDirective.prototype.elementRef;
    /**
     * @type {?}
     * @private
     */
    IfPersonallyIdentifiableInformationDirective.prototype.renderer;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/pipes/update-resource-location.pipe.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class UpdateResourceLocationPipe {
    /**
     * @param {?} settings
     */
    constructor(settings) {
        this.settings = settings;
    }
    /**
     * @param {?} resource
     * @return {?}
     */
    transform(resource) {
        if (this.settings.hasResourcePrefix && resource.startsWith('/') && !resource.startsWith('//')) {
            if (this.settings.resourcePrefix.charAt(this.settings.resourcePrefix.length - 1) === '/') {
                return `${this.settings.resourcePrefix}${resource.substring(1)}`;
            }
            else {
                return `${this.settings.resourcePrefix}${resource}`;
            }
        }
        else if (resource.charAt(0) !== '/' && this.settings.resourcePrefix.charAt(this.settings.resourcePrefix.length - 1) !== '/') {
            return `${this.settings.resourcePrefix}/${resource}`;
        }
        return resource;
    }
}
UpdateResourceLocationPipe.ɵfac = function UpdateResourceLocationPipe_Factory(t) { return new (t || UpdateResourceLocationPipe)(ɵngcc0.ɵɵdirectiveInject(SettingsService, 16)); };
UpdateResourceLocationPipe.ɵpipe = /*@__PURE__*/ ɵngcc0.ɵɵdefinePipe({ name: "updateResourceLocation", type: UpdateResourceLocationPipe, pure: true });
/** @nocollapse */
UpdateResourceLocationPipe.ctorParameters = () => [
    { type: SettingsService }
];
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(UpdateResourceLocationPipe, [{
        type: Pipe,
        args: [{ name: 'updateResourceLocation' }]
    }], function () { return [{ type: SettingsService }]; }, null); })();
if (false) {
    /**
     * @type {?}
     * @private
     */
    UpdateResourceLocationPipe.prototype.settings;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/core-ng.module.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class CoreNg {
    /**
     * @param {?} injector
     */
    constructor(injector) {
        AppInjector.setInjector(injector);
    }
    /**
     * @return {?}
     */
    static forRoot() {
        return {
            ngModule: CoreNg,
            providers: [
                LastResponseService,
                SettingsService,
                ReferrerService,
                RouteOverrideService,
                ParamsService,
                CustomerService,
                { provide: CoreNgOptions, useFactory: CoreNgOptionsFactory },
                Http,
                SignOutService,
                GoogleTagManagerService,
                GoogleOptimizeService,
                HotJarService,
                IfSessionService
            ]
        };
    }
}
CoreNg.ɵfac = function CoreNg_Factory(t) { return new (t || CoreNg)(ɵngcc0.ɵɵinject(ɵngcc0.Injector)); };
CoreNg.ɵmod = /*@__PURE__*/ ɵngcc0.ɵɵdefineNgModule({ type: CoreNg });
CoreNg.ɵinj = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjector({ imports: [[CommonModule, ReactiveFormsModule, RouterModule, FormsModule]] });
/** @nocollapse */
CoreNg.ctorParameters = () => [
    { type: Injector }
];
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(CoreNg, [{
        type: NgModule,
        args: [{
                imports: [CommonModule, ReactiveFormsModule, RouterModule, FormsModule],
                declarations: [
                    GoogleAnalyticsComponent,
                    IFDatePipe,
                    HotjarDirective,
                    IfPersonallyIdentifiableInformationDirective,
                    UpdateResourceLocationPipe
                ],
                exports: [
                    GoogleAnalyticsComponent,
                    IFDatePipe,
                    HotjarDirective,
                    IfPersonallyIdentifiableInformationDirective,
                    UpdateResourceLocationPipe
                ]
            }]
    }], function () { return [{ type: ɵngcc0.Injector }]; }, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(CoreNg, { declarations: function () { return [GoogleAnalyticsComponent, IFDatePipe, HotjarDirective, IfPersonallyIdentifiableInformationDirective, UpdateResourceLocationPipe]; }, imports: function () { return [CommonModule, ReactiveFormsModule, RouterModule, FormsModule]; }, exports: function () { return [GoogleAnalyticsComponent, IFDatePipe, HotjarDirective, IfPersonallyIdentifiableInformationDirective, UpdateResourceLocationPipe]; } }); })();
/**
 * @return {?}
 */
function CoreNgOptionsFactory() {
    return new CoreNgOptions(true);
}

/**
 * @fileoverview added by tsickle
 * Generated from: public_api.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */

/**
 * @fileoverview added by tsickle
 * Generated from: inflight-core-ng.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */

export { AppInjector, CoreNg, CoreNgOptions, CoreNgOptionsFactory, CustomerService, EndHttpEvent, ErrorHttpEvent, GTMHelper, GoogleAnalyticsComponent, GoogleOptimizeService, GoogleTagManagerService, HotJarService, HotjarDirective, Http, HttpEvent, IFDatePipe, IFDatePipeParams, IfPersonallyIdentifiableInformationDirective, IfSessionService, LastResponseService, ParamsService, ReferrerService, RouteOverrideService, SettingsConfig, SettingsService, SignOutService, StartHttpEvent, UpdateResourceLocationPipe };

